module.exports = __webpack_public_path__ + "img/warning_blue.99f95c7c.svg";